import React, {useContext} from "react";
import parse from "html-react-parser";
import {RecordsManagementContext} from "../StatesMangement/InitialiseContext";

export default () => {//show details of the estimate addresses.
    let IV2_PageDetails = useContext(RecordsManagementContext).IV2_PageDetails
    let IV1_PageDetails = useContext(RecordsManagementContext).IV1_PageDetails
    return (
        <div className='border border-top-0 border-dark px-sm-2'>
            <div className="row">
                <div className="col-sm-1 border-right border-dark d-flex align-items-center">
                    <b>ORIGIN</b>
                </div>
                <div className="col-lg-3 border-right border-dark">
                    {parse(`${IV2_PageDetails.EstAddress.OriginAddress}`)}
                </div>
                <div className="col-sm-1 border-right border-dark d-flex align-items-center">
                    <b>STOPS</b>
                </div>
                <div className="col-sm-3 border-right border-dark">
                    {IV2_PageDetails.ExtraStops.length?
                        <div className="col">{IV2_PageDetails.ExtraStops.map((stop, key) => {
                            return (
                                <div key={key+"extra_stop1"}><p key={key+"extra_stop"}>{stop.Address}</p><br/>
                                    <p key={key+"extra_stop_apartment"}>
                                        {stop.Description? <>Description : {stop.Description} <br/></> : ""}
                                        {stop.Apartment? <>SUITE/APT : {stop.Apartment}<br/></> : ""}
                                        {stop.Floor ? <>Floor(s) : {stop.Floor}</>  : "" }</p>
                                </div>
                            )
                        })}</div>
                        :
                        <div className="col">
                            No Extra Stops
                        </div>
                    }
                </div>
                <div className="col-lg-1 border-right border-dark d-flex align-items-center">
                    <b>DESTIN</b>
                </div>
                <div className="col-sm-3 text-sm-right">
                    {parse(`${IV2_PageDetails.EstAddress.DestinationAddress}`)}
                </div>
            </div>
        </div>
    )
}